"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var index_1 = __importDefault(require("@components/Modal/index"));
var Button_1 = __importDefault(require("@components/Button"));
var react_i18next_1 = require("react-i18next");
var clsx_1 = __importDefault(require("clsx"));
function QueueNameModal(props) {
    var onConfirm = props.onConfirm, isOpen = props.isOpen, setIsOpen = props.setIsOpen, isEditMode = props.isEditMode, existingQueueNames = props.existingQueueNames, selectedQueueName = props.selectedQueueName;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _a = __read(react_1.default.useState(selectedQueueName || ''), 2), queueName = _a[0], setQueueName = _a[1];
    var isQueueNameDuplicate = existingQueueNames.includes(queueName) && queueName !== selectedQueueName;
    var title = isEditMode ? 'MANUAL.EDIT_QUEUE_POPOVER.TITLE' : 'MANUAL.ADD_QUEUE_POPOVER.TITLE';
    var buttonText = isEditMode ? 'MANUAL.EDIT_QUEUE_POPOVER.BTN' : 'MANUAL.ADD_QUEUE_POPOVER.BTN';
    (0, react_1.useEffect)(function () {
        setQueueName(selectedQueueName || '');
    }, [selectedQueueName]);
    var closeModal = function () {
        setIsOpen(false);
        setQueueName('');
    };
    return (react_1.default.createElement(index_1.default, { isOpen: isOpen, setIsOpen: closeModal, modalContentClassName: "modalContent" },
        react_1.default.createElement("div", { className: "add-queue-modal" },
            react_1.default.createElement("h3", { className: "title" }, t(title)),
            react_1.default.createElement("div", { className: "flex-container" },
                react_1.default.createElement("div", { className: (0, clsx_1.default)('add-queue-modal-input-container', { invalid: isQueueNameDuplicate || !queueName }) },
                    react_1.default.createElement("label", null,
                        t('MANUAL.ADD_QUEUE_POPOVER.LABEL'),
                        " "),
                    react_1.default.createElement("input", { value: queueName, onChange: function (e) { return setQueueName(e.target.value); }, name: "queue-name-input" })),
                react_1.default.createElement(Button_1.default, { text: t(buttonText), onClick: function () {
                        onConfirm(queueName);
                    }, disabled: isQueueNameDuplicate || !queueName, className: "confirm-btn" })),
            isQueueNameDuplicate && react_1.default.createElement("p", { className: "warning-text" }, t('MANUAL.ADD_QUEUE_POPOVER.ERROR_TEXT')))));
}
exports.default = QueueNameModal;
